<template>
  <div>
    <v-dialog v-model="newTicket.dialog" persistent max-width="900">
      <v-card>
        <v-card-title>
          <span class="headline">New request send by technician</span>
        </v-card-title>
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-layout row>
                <v-flex xs12 sm5 v-if="!newTicket.isCustomName">
                  <v-autocomplete
                    :items="allUsers"
                    v-model="newTicket.requester"
                    label="Select Requester"
                    placeholder="Start typing..."
                    ref="newTicketRequester"
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm5 v-if="newTicket.isCustomName">
                  <v-text-field
                    v-model="newTicket.customName"
                    label="Enter Name"
                    ref="newTicketCustomName"
                    :rules="newTicket.isCustomName ? [rules.required] : []"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-checkbox
                    v-model="newTicket.isCustomName"
                    label="Custom Name"
                    ref="newTicketIsCustomName"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    v-model="newTicket.priority"
                    :items="['High', 'Normal', 'Low']"
                    label="Priority"
                    ref="newTicketSelectedPriority"
                    :rules="[rules.required]"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-autocomplete
                    v-model="newTicket.category"
                    placeholder="Start typing..."
                    :items="[
                      'Attendance',
                      'Backup',
                      'Battery',
                      'Bogen/Valcom',
                      'Browser',
                      'Camera',
                      'Citrix',
                      'Desktop / Laptop /Server',
                      'Door Bell',
                      'Email',
                      'FAX',
                      'Full alarm',
                      'General',
                      'Home Assistant',
                      'Intercom / Access',
                      'Internet',
                      'iPad',
                      'Misc',
                      'Monitor',
                      'Network',
                      'Operating System',
                      'Printers / scanner / Fax',
                      'Projecor',
                      'Projects',
                      'Purchasing',
                      'Recordings',
                      'Routers',
                      'Services',
                      'Software',
                      'Switches',
                      'Tasks of IT Projects',
                      'Telephone',
                      'Thank You message',
                      'Time-Clock',
                      'Untitled',
                      'User Administration',
                      'Voter Office',
                      'Warranty /Contract',
                      'Wireless',
                    ]"
                    label="Category"
                    :rules="[rules.required]"
                    ref="newTicketCategory"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout row> </v-layout>
              <v-flex xs12 sm8>
                <v-text-field
                  v-model="newTicket.subject"
                  label="Enter a brief title for your request"
                  ref="newTicketSubject"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-Textarea
                  rows="2"
                  v-model="newTicket.description"
                  label="Write a message"
                  outline
                  ref="newTicketDescription"
                ></v-Textarea>
              </v-flex>
              <v-layout row>
                <v-icon>mdi-phone</v-icon>
                <v-flex xs12 sm5>
                  <v-text-field v-model="newTicket.phone" label="Phone Number">
                  </v-text-field>
                </v-flex>

                <v-flex xs12 sm3>
                  <v-text-field
                    v-model="newTicket.ext"
                    label="Ext Number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field
                    v-model="newTicket.room"
                    label="Room Number"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-flex xs6 sm9>
                <v-Textarea
                  rows="1"
                  v-model="newTicket.internalNote"
                  label="Internal Note"
                  ref="newTicketInternalNote"
                ></v-Textarea>
              </v-flex>
              <v-flex xs6 sm3>
                <v-select
                  v-model="newTicket.urgency"
                  label="Urgency"
                  ref="newTicketUrgency"
                  :items="['Today', '2 Days', 'Week', 'Month']"
                ></v-select>
              </v-flex>
              <v-layout row>
                <v-flex xs12 sm4>
                  <v-radio-group
                    label="Select Days Schedule"
                    v-model="newTicket.scheduleDaysType"
                  >
                    <v-radio
                      label="Regular days (Mon - Thu)"
                      value="reg-days"
                    ></v-radio>
                    <v-radio label="Custom days" value="custom-days"></v-radio>
                  </v-radio-group>
                  <div
                    v-if="newTicket.scheduleDaysType === 'custom-days'"
                    class="d-flex align-center mt-0"
                  >
                    <v-select
                      v-model="newTicket.scheduleCustomSelectedDays"
                      :items="['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri']"
                      label="Select Days"
                      multiple
                      chips
                      closable-chips
                      :rules="[
                        (v) => v.length > 0 || 'At least one day is required',
                      ]"
                      style="max-width: 190px;"
                    ></v-select>
                  </div>

                  <!-- Keep your original model updated -->
                  <input type="hidden" :value="newTicket.schedule" />
                </v-flex>
                <v-flex xs12 sm4>
                  <v-radio-group
                    label="Select a Time Schedule"
                    v-model="newTicket.scheduleTimeType"
                  >
                    <v-radio
                      label="Reg hours 9:30 AM - 5:00 PM"
                      value="reg-hours"
                    ></v-radio>
                    <v-radio
                      label="Custom hours"
                      value="custom-hours"
                    ></v-radio>
                  </v-radio-group>
                  <div
                    v-if="newTicket.scheduleTimeType === 'custom-hours'"
                    class="d-flex align-center mt-0"
                  >
                    <v-text-field
                      v-model="newTicket.scheduleStartTime"
                      :rules="[rules.required]"
                      label="From"
                      type="time"
                      class="mr-4"
                      style="max-width: 160px;"
                    ></v-text-field>

                    <span class="mx-2">to</span>

                    <v-text-field
                      v-model="newTicket.scheduleEndTime"
                      :rules="[rules.required]"
                      label="To"
                      type="time"
                      style="max-width: 160px;"
                    ></v-text-field>
                  </div>

                  <!-- Keep your original model updated -->
                  <input type="hidden" :value="newTicket.schedule" />
                </v-flex>
                <v-flex xs12 sm3>
                  <v-checkbox
                    v-model="newTicket.affectedMany"
                    label="Affected many"
                    ref="newTicketAffect"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="newTicket.specialEntry"
                    label="Special Entry Info"
                    ref="newTicketSpecialEntry"
                  ></v-checkbox>
                  <v-text-field
                    v-if="newTicket.specialEntry"
                    v-model="newTicket.specialEntryInfo"
                    label="Enter the info"
                    ref="newTicketSpecialEntryInfo"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-flex xs12 sm8> </v-flex>
            </v-layout>
          </v-container>

          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>

            <v-btn
              :loading="processing"
              color="default"
              @click="closeDialog"
              :dark="true"
              :disabled="false"
              >Cancel</v-btn
            >
            <v-btn
              :loading="processing"
              dark
              color="success"
              @click="saveNewTicket"
              >Send</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    rules: {
      required: (value) => !!value || "Required.",
    },
    newTicket: {
      dialog: Boolean,
      subject: "",
      description: "",
      category: "",
      priority: "Normal",
      phone: "",
      room: "",
      ext: "",
      requester: "",

      affectedMany: false,

      scheduleDaysType: "reg-days",
      scheduleCustomSelectedDays: [],

      scheduleTimeType: "reg-hours",
      scheduleStartTime: "",
      scheduleEndTime: "",

      specialEntry: false,
      specialEntryInfo: "",

      urgency: "",

      internalNote: "",

      isCustomName: false,
      customName: "",
    },
    allUsers: [],
    users: [],
    mappedExtensions: [],
    mappedPhones: [],
    usersContactMapping: [],
    processing: false,
  }),
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.newTicket.dialog = val;
        if (val == true) {
          this.loadUsers();
        }
      },
    },
    "newTicket.dialog"(val) {
      this.$emit("input", val);
      if (!val) {
        this.resetForm();
      }
    },
  },

  methods: {
    async saveNewTicket() {
      if (!this.$refs.form.validate(true)) {
        return;
      }
      try {
        this.processing = true;
        const hasUserInfo =
          this.newTicket.phone ||
          this.newTicket.room.trim() ||
          this.newTicket.ext.trim();

        const userInfo = [
          this.newTicket.phone
            ? `<b>Phone</b>: ${this.newTicket.phone}<br>`
            : "",
          this.newTicket.room.trim()
            ? `<b>Room</b>: ${this.newTicket.room.trim()}<br>`
            : "",
          this.newTicket.ext.trim()
            ? `<b>Ext</b>: ${this.newTicket.ext.trim()}`
            : "",
        ]
          .filter(Boolean)
          .join("");

        const desc = `${this.newTicket.description.trim()}${
          hasUserInfo ? `<br><br><br><br>${userInfo}` : ""
        }`;
        const description = desc
          .replace(/  /g, "&nbsp;")
          .replace(/\n/g, "<br>");
        const priorityMap = {
          High: "3 Option 8",
          Normal: "2 Normal",
          Low: "4 Low",
        };

        var scheduleDays = "";
        var scheduleHours = "";

        if (this.newTicket.scheduleDaysType != "reg-days") {
          scheduleDays = this.newTicket.scheduleCustomSelectedDays;
        } else {
          scheduleDays = "Regular days";
        }

        if (this.newTicket.scheduleTimeType != "reg-hours") {
          scheduleHours = `${this.newTicket.scheduleStartTime} - ${
            this.newTicket.scheduleEndTime
          }`;
        } else {
          scheduleHours = "Regular hours";
        }
        // const techData1 = {
        //   AffectedMany: this.newTicket.affectedMany,
        //   ScheduleDays: JSON.stringify(scheduleDays),
        //   ScheduleHours: scheduleHours,
        //   SpecialEntryInfo: this.newTicket.specialEntryInfo,
        //   Urgency: this.newTicket.urgency,
        //   InternalNote: this.newTicket.internalNote,
        //   CustomName: this.newTicket.customName,
        // };
        const techData = [
          this.newTicket.isCustomName
            ? `<b>Name</b>: ${this.newTicket.customName}<br><br>`
            : "",
          `<b>Affected Many</b>: ${
            this.newTicket.affectedMany ? "Yes" : "No"
          }<br><br>`,
          this.newTicket.urgency
            ? `<b>Urgency</b>: ${this.newTicket.urgency}<br><br>`
            : "",
          `<b>Schedule Days</b>: ${
            scheduleDays === "Regular days"
              ? scheduleDays
              : JSON.stringify(scheduleDays)
          }<br><br>`,
          `<b>Schedule Hours</b>: ${scheduleHours}<br><br>`,
          this.newTicket.specialEntryInfo
            ? `<b>Special Entry Info</b>: ${
                this.newTicket.specialEntryInfo
              }<br><br>`
            : "",
          this.newTicket.internalNote
            ? `<b>Internal Note</b>: ${
                this.newTicket.internalNote
              }<br><br><br><br>`
            : "",
          `This ticket has been submitted on behalf of Technician ${
            this.$store.state.authentication.user
          } through the User Portal application`,
        ]
          .filter(Boolean)
          .join("");

        const requester = () => {
          const mapUserByExt = this.usersContactMapping.find(
            (m) => m.extension == this.newTicket.requester
          );

          const mapUserByPhone = this.usersContactMapping.find(
            (m) => m.phone == this.newTicket.requester
          );

          if (mapUserByExt && mapUserByExt.extension) {
            return mapUserByExt.manageengineEmail
              ? mapUserByExt.manageengineEmail
              : mapUserByExt.manageengineUserID;
          } else if (mapUserByPhone && mapUserByPhone.phone) {
            return mapUserByPhone.manageengineEmail
              ? mapUserByPhone.manageengineEmail
              : mapUserByPhone.manageengineUserID;
          } else {
            return this.newTicket.requester;
          }
        };

        const payload = {
          User: !this.newTicket.isCustomName
            ? requester()
            : "defaultuser@utaw.org",
          Subject: this.newTicket.subject.trim(),
          Description: description,
          Priority: priorityMap[this.newTicket.priority],
          Category: this.newTicket.category
            ? this.newTicket.category
            : "Untitled",
          Urgency: this.newTicket.urgency,
          TechData: techData,
        };
        const response = await this.$http.post(
          "api/Manageengine/ManageenginePost",
          payload
        );

        this.processing = false;

        this.$notify({
          text: "Ticket Created",
          group: "notification",
          type: "success",
        });
        this.newTicket.dialog = false;
        await this.$http.get(
          `api/manageengine/getRequestbyID?id=${response.request.display_id}`
        );
        this.$emit("newTicketSended");

        // this.$router.push({
        //   name: "HelpDeskRequestView",
        //   params: { id: response.request.display_id },
        // });
      } catch (e) {
        this.processing = false;
        this.cancelBtnAbility = false;
        alert(
          `We're sorry, but your ticket could not be submitted. Make sure the username is mapped`
        );
      }
    },

    closeDialog() {
      this.newTicket.dialog = false;
    },
    resetForm() {
      this.newTicket = {
        dialog: false,
        subject: "",
        description: "",
        category: "",
        priority: "Normal",
        phone: "",
        room: "",
        ext: "",
        requester: "",
        affectedMany: false,
        scheduleDaysType: "reg-days",
        scheduleCustomSelectedDays: [],
        scheduleTimeType: "reg-hours",
        scheduleStartTime: "",
        scheduleEndTime: "",
        specialEntry: false,
        specialEntryInfo: "",
        urgency: "",
        internalNote: "",
        isCustomName: false,
        customName: "",
      };
      this.$refs.form.resetValidation(true);
    },
    async loadUsers() {
      const response = await this.$http.get(`/odata/users?$count=true`);
      this.users = response.value.map((u) => u.userName);
      await this.loadManageEngineUsersContactMapping();
      this.allUsers = [
        ...this.users,
        ...this.mappedExtensions,
        ...this.mappedPhones,
      ];
    },

    async loadManageEngineUsersContactMapping() {
      const response = await this.$http.get(
        "api/manageengine/getManageEngineUsersContactMapping"
      );
      this.usersContactMapping = response;
      this.mappedExtensions = response
        .map((m) => m.extension)
        .filter((extension) => extension);
      this.mappedPhones = response.map((m) => m.phone).filter((phone) => phone);
    },
  },
};
</script>
